

export default {
	name: 'Notify',
	props: {
		data: Object
	},
	data: function() {
		return {
		};
	}
};
